import download from './download/index';
var path = '/company';
var company = function (url) { return function () { return ({
    download: download("" + url + path)
}); }; };
export default company;
